import { render, staticRenderFns } from "./BuscarReferidoComponent.vue?vue&type=template&id=632ab5d9"
import script from "./BuscarReferidoComponent.vue?vue&type=script&lang=js"
export * from "./BuscarReferidoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports